import {texture} from "p3";
import definitions from "../../../definitions";
import Item from "./Item";

export default class ItemCollectionJarBlueFlowersFull extends Item {
    constructor() {
        super(definitions.ITEM_ID.COLLECTION_JAR_BLUE_FLOWERS_FULL, texture("prop_collection_jar_blue_flowers_00"));
    }

    init() {
        super.init();

        this.addShadow(definitions.SHADOW_SIZE.SMALL, 0.6, new PIXI.Point(3, 0));
    }
}